__turbopack_context__.v({
  "title": "category-products-module__1dxNOW__title",
  "wrapper": "category-products-module__1dxNOW__wrapper",
});
